import React, { Component } from 'react';
import Logo from './images/logo.svg';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Main from './Main';
import menu from './images/menu.svg';
import { animateScroll as scroll } from 'react-scroll';
import { slide } from 'react-burger-menu';
import Documentation from './Documentation';

export default class Header extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             isHide: true
        }

        this.menu = this.menu.bind(this);
    }
    

    menu(){
        if(this.state.isHide){
            this.refs.menu.style.visibility = "visible";
            this.refs.menu.style.opacity = 1;
            this.setState({
                isHide: false
            })
        }else{
            this.refs.menu.style.opacity = 0;
            this.refs.menu.style.visibility = "hidden";
            this.setState({
                isHide: true
            })
        }
    }

    render() {
        return (
            <Router>
                <div className='header'>
                    <div className="header__inner">
                        <div className="header__item">
                            <img src={Logo} alt="" className="header__logo"/>
                        </div>
                        <div className="header__item">
                            <Link to="/" className="header__link">Главная</Link>
                            <Link to='/' onClick={() => scroll.scrollTo(1000)} className="header__link">О нас</Link>
                            <Link to="/documentation" className="header__link">Документация</Link>
                            <Link to='/' onClick={() => scroll.scrollTo(2000)} className="header__btn">Начать</Link>
                            <img src={menu} className='menu' onClick={this.menu} />
                        </div>
                    </div>
                    <div ref='menu' className="header__menu">
                        <Link to="/" className="header__m_link">Главная</Link>
                        <a  onClick={() => scroll.scrollTo(550)} className="header__m_link">О нас</a>
                        <Link to="/documentation" className="header__m_link">Документация</Link>
                    </div>
                </div>

                <Switch>
                    <Route path='/documentation'>
                        <Documentation></Documentation>
                    </Route>
                    <Route path='/'>
                        <Main></Main>
                    </Route>
                </Switch>

                <div className='footer'>
                    <p className="footer__title">Навигация</p>
                    <Link to='/' onClick={() => scroll.scrollToTop()} className="footer__link">Главная</Link>
                    <Link to='documentation' className="footer__link">Документация</Link>
                </div>
            </Router>
        )
    }
}
